import React from 'react';
import ReactDOM from 'react-dom';
import { Table } from '../table';

const Realize = {
	GridTable: window.GridTable,
};

export default class GridTable extends Realize.GridTable {
	static defaultProps = {
		...Realize.GridTable.defaultProps,
		tableComponent: Table,
		contextType: 'GRID',
		isMobile: false,
	};

	constructor(props) {
		super(props);
		this.render = GridTable.prototype.render.bind(this);
	}

	componentDidMount() {
		if (!this.props.isMobile) {
			document.addEventListener('keyup', this.calculateTableScrollAsInColumn.bind(this));
		}
	}

	componentDidUnmount() {
		if (!this.props.isMobile) {
			document.removeEventListener('keyup', this.calculateTableScrollAsInColumn.bind(this));
		}
	}

	calculateTableScrollAsInColumn (event) {
		const isTabEvent = event.key === 'Tab';

		if (!isTabEvent) return;

		const focusedElement = document.activeElement;
		const isTableHeader = focusedElement && focusedElement.classList.contains('table-header');
		const isCellContent = focusedElement && focusedElement.classList.contains('table-cell__content');

		if (!isTableHeader && !isCellContent) return;

		const table = ReactDOM.findDOMNode(this.refs.gridTableContainer);

		let offsetLeft = focusedElement.offsetLeft;

		if (isCellContent) {
			const tableCell = $(focusedElement).closest('.table-cell');

			if (!tableCell.length) return;

			let paddingLeft = 10;
			offsetLeft = tableCell.get(0).offsetLeft - paddingLeft;
		}

		table.scrollLeft = offsetLeft;
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.dataRows !== this.props.dataRows && this.props.dataRows.length > 0 && this.props.contextType === 'GRID') {
			setTimeout(() => {
				const $gridTableContainer = $(ReactDOM.findDOMNode(this.refs.gridTableContainer));
				const $gridTable = $gridTableContainer.find('table');
				const $gridTableRow = $gridTable.find('.table-row');
				const $containerColumnFixed = $(ReactDOM.findDOMNode(this.refs.containerColumnFixed));

				$containerColumnFixed.html("");

				$gridTableRow.each((index, elem) => {
					const $row = $(elem);
					const $rowActions = $row.find(".table-row__actions");

					$rowActions.height($row.height());

					$containerColumnFixed.append(`<div style="height: ${$row.height()}px; background-color: ${$row.css("backgroundColor")}";></div>`);
				});

				if ($gridTable.width() <= $gridTableContainer.width())
					$containerColumnFixed.css("boxShadow", "none");
				else
					$containerColumnFixed.css("boxShadow", "-6px 0 6px -4px rgba(0, 0, 0, 0.15)");
			}, 1000);
		}
	}

	renderColumnsFixed() {
		if (this.props.dataRows.length !== 0 && this.props.contextType === 'GRID' && !this.props.readOnly)
			return (
				<div className="container-column-fixed" ref="containerColumnFixed"></div>
			);
	}

	render() {
		const { tableComponent: TableComponent } = this.props;

		return(
			<div className={this.className()}>
				<TableComponent
					{...this.propsWithoutCSS()}
					contextType={this.props.contextType}
					className={`${this.props.tableClassName}`}
					clearTheme={this.props.clearThemeTable}
					ref='gridTableContainer'
					onSortTable={this.props.onSortTable}
					filterClientSideTable={this.props.filterClientSideTable}
					isMobile={this.props.isMobile}
					fields={this.props.fields}
				/>
			</div>
		);
	}
}
